import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import "../../styleAllServices.css";
import soilImg from "../../../../assets/img/mulch-soil-preparation.png";
import lawnImg from "../../../../assets/img/soil-sample.jpg";

export default function Topdressing() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    let linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) { linkTag.setAttribute("href", canonicalUrl); }
    else {
      linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "canonical");
      linkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkTag);
    }
    document.title = "Lawn Topdressing Vancouver | Compost & Soil Improvement | BUR-HAN";
    const desc = "Professional lawn topdressing in Vancouver. Improve soil health, reduce thatch and grow thicker grass with BUR-HAN's compost topdressing service. Free quote: 604-983-2687";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) { metaDesc.setAttribute("content", desc); }
    else {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      metaDesc.setAttribute("content", desc);
      document.head.appendChild(metaDesc);
    }
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) { ogTitle.setAttribute("content", document.title); }
    else {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      ogTitle.setAttribute("content", document.title);
      document.head.appendChild(ogTitle);
    }
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) { ogDesc.setAttribute("content", desc); }
    else {
      ogDesc = document.createElement("meta");
      ogDesc.setAttribute("property", "og:description");
      ogDesc.setAttribute("content", desc);
      document.head.appendChild(ogDesc);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        <h1 data-aos="zoom-in">Lawn Topdressing Vancouver</h1>
      </div>
      <div className="serviceItemsMain">
        <h2 data-aos="fade-down">
          "Feed your soil from the top down — the foundation of a truly healthy lawn."
        </h2>
        <hr />
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy" src={soilImg}
              alt="Compost and soil preparation for lawn topdressing in Vancouver"
              title="Lawn Topdressing with Compost — BUR-HAN Vancouver"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">What Is Lawn Topdressing?</h3>
            <p>
              Topdressing is the application of a thin, even layer of high-quality compost or sandy loam across your lawn surface. It is one of the most beneficial things you can do for lawn soil health, and a standard practice for golf courses and professional sports turf — now available for your home lawn.
            </p>
            <p>
              BUR-HAN typically applies topdressing in combination with aeration and overseeding in spring or fall. When applied after core aeration, the compost fills the holes and integrates with the existing soil, dramatically improving its structure, biology, and fertility.
            </p>
          </div>
        </section>
        <section className="section-container">
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">Benefits of Lawn Topdressing</h3>
            <ul>
              <li><strong>Improves soil structure:</strong> Compost breaks up clay-heavy soils and improves drainage in compacted Vancouver lawns.</li>
              <li><strong>Reduces thatch:</strong> Beneficial microbes in compost actively break down the thatch layer, reducing buildup without dethatching.</li>
              <li><strong>Levels uneven surfaces:</strong> Repeated topdressing gradually levels low spots and bumpy areas in older lawns.</li>
              <li><strong>Boosts microbial activity:</strong> Compost introduces beneficial soil organisms that improve long-term soil fertility and disease resistance.</li>
              <li><strong>Enhances seed germination:</strong> When combined with overseeding, topdressing provides the perfect seedbed for new grass establishment.</li>
              <li><strong>Reduces fertilizer dependency:</strong> Healthy, biologically active soil requires less synthetic input to maintain a green, thick lawn.</li>
            </ul>
          </div>
          <div className="image-container px-5" data-aos="fade-left">
            <img loading="lazy" src={lawnImg}
              alt="Soil sample showing improved soil health after lawn topdressing in Vancouver"
              title="Healthy Soil After Topdressing — Vancouver Lawn Care"
            />
          </div>
        </section>

        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Residential Lawn Care Services</h2>
          <div className="lawnCareLinks-grid">
      <a href="/services/residential-lawn-care">
        <strong>Residential Lawn Care</strong>
        <span>All lawn care services</span>
      </a>
      <a href="/services/residential-lawn-care/liming">
        <strong>Lawn Liming</strong>
        <span>Soil pH correction</span>
      </a>
      <a href="/services/residential-lawn-care/moss-control">
        <strong>Moss Control</strong>
        <span>Treatment & prevention</span>
      </a>
      <a href="/services/residential-lawn-care/organic-weed-control">
        <strong>Organic Weed Control</strong>
        <span>Pesticide-free weed management</span>
      </a>
      <a href="/services/residential-lawn-care/overseeding">
        <strong>Overseeding</strong>
        <span>Thicken & repair your lawn</span>
      </a>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>Fill out our Get a Quote page and let BUR-HAN recommend the right topdressing program for your Vancouver lawn this season.</p>
              </div>
              <div className="col-md-6">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">Get A Quote</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
